import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	finalOverview: {
		position: 'absolute',
		top: '-46rem',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '70vw !important',
		height: '70vh',
		backgroundColor: '#fff',
		boxShadow: 24,
		borderRadius: '10px',
		padding: '3rem',
		overflow: 'scroll'
	}
}));
